<template>
    <div>
        <MercenaryHeader :title="'활동지원'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex:1; background-color: #f5f5f5; padding:12px;">

            <div class="tit" style="margin-top:20px; color:#210F03; font-size:16px; font-weight:500; ">활동지원</div>
            <div class="btns" style="display:flex; align-items: center; height:48px; background-color: white; border-radius:12px; margin-top:10px; padding:0px 12px;">
                <a class="btn add" style="color:#210F03; font-size:14px; flex:1; font-weight:500;" @click="showCustomerSupport(); $Util.sendEventClick('활동및설정_고객지원요청')">사커하우 고객지원 요청하기</a>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>

            <div class="tit" style="margin-top:20px; color:#210F03; font-size:16px; font-weight:500; ">피드백</div>
            <div class="btns" style="display:flex; align-items: center; height:48px; background-color: white; border-radius:12px; margin-top:10px; padding:0px 12px;">
                <a class="btn add" style="color:#210F03; font-size:14px; flex:1; font-weight:500;" @click="showFeedBackWriteForm(); $Util.sendEventClick('활동및설정_피드백보내기')">피드백 보내기</a>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>

            <div class="tit" style="margin-top:20px; color:#210F03; font-size:16px; font-weight:500; ">신고내역</div>
            <div class="btns" style="display:flex; align-items: center; height:48px; background-color: white; border-radius:12px; margin-top:10px; padding:0px 12px;">
                <a class="btn add" style="color:#210F03; font-size:14px; flex:1; font-weight:500;" @click="showReportHistory(); $Util.sendEventClick('활동및설정_신고내역전체보기')">신고내역 전체보기</a>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
        </div>
        <CustomerSupport :isOpenCustomerSupport="isOpenCustomerSupport" :closeCustomerSupport="closeCustomerSupport"></CustomerSupport>
        <FeedBackWriteForm :isOpenFeedBack="isOpenFeedBack" :closeFeedBack="closeFeedBack"></FeedBackWriteForm>
    </div>
</template>

<script>
import MercenaryHeader from "@/components/common/MercenaryHeader";
import CustomerSupport from "@/components/modal/my/CustomerSupport";
import FeedBackWriteForm from "@/components/modal/my/FeedBackWriteForm";
export default {
    name: "SupportActivity",
    components: { MercenaryHeader, CustomerSupport, FeedBackWriteForm },
    data() {
        return {
            isOpenCustomerSupport: false,
            isOpenFeedBack: false,
        }
    },
    methods: {
        showFeedBackWriteForm() {
            this.isOpenFeedBack = true;
        },
        showCustomerSupport() {
            this.$GlobalStore.addModal('SoccerhowCustomerSupport')
        },
        showReportHistory() {
            this.$GlobalStore.addModal('ReportHistoryNew')
        },
        closeCustomerSupport() {
            this.isOpenCustomerSupport = false;
        },
        closeFeedBack() {
            this.isOpenFeedBack = false;
        }
    }
}
</script>

<style scoped></style>